import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const inputCls = "w-full bg-white/[0.04] border border-white/15 focus:border-[#E50914] outline-none px-4 py-3 text-white transition-colors";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err, "Accesso non riuscito"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B0C0E]">
      <div className="hidden lg:block relative grain">
        <img src="/images/blacktruck.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/20" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-display text-5xl font-black uppercase text-white leading-none">Pannello<br />amministrativo</p>
          <p className="mt-4 text-slate-300">Gestione spedizioni, tracking e statistiche aziendali.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
          <Link to="/" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-slate-500 hover:text-white" data-testid="login-back-home"><ArrowLeft className="h-3.5 w-3.5" /> Torna al sito</Link>
          <img src="/logo.jpg" alt="LINCESSO GROUP TRASPORTI" className="mt-6 h-28 w-auto -ml-3" />
          <h1 className="mt-6 font-display text-3xl font-black uppercase text-white flex items-center gap-3"><Lock className="h-6 w-6 text-[#E50914]" /> Area riservata</h1>
          <p className="mt-2 text-sm text-slate-400">Accesso consentito solo agli amministratori autorizzati.</p>
          <div className="mt-8 space-y-5">
            <label className="block">
              <span className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Email</span>
              <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" />
            </label>
            <label className="block">
              <span className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Password</span>
              <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" />
            </label>
            {error && <p className="text-sm text-red-400 border border-red-500/30 bg-red-500/10 px-4 py-3" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={busy} className="w-full inline-flex items-center justify-center gap-2 bg-[#E50914] hover:bg-[#C10710] disabled:opacity-60 text-white py-4 font-display text-lg font-bold uppercase tracking-wider transition-colors" data-testid="admin-login-submit">
              {busy && <Loader2 className="h-5 w-5 animate-spin" />} Accedi
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
